export default {
  index: "/",
}
